import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FeedbackModal from '../containers/FeedbackModal';

const FeedbackPopup = ({
  isFeedbackBetaFeatureEnabled,
  isPopupOpened,
  isUserLoggedIn,
  toggleFeedbackPopup,
}) => {
  if (!isFeedbackBetaFeatureEnabled || !isUserLoggedIn) {
    return null;
  }

  return (
    <Fragment>
      <button
        className={classNames(
          'fp-feedbackTriggerButton',
          { 'fp-feedbackTriggerButton--hidden': isPopupOpened }
        )}
        onClick={toggleFeedbackPopup}
      >
        <span className="fp-feedbackTriggerButton__text">
          Feedback
        </span>
      </button>

      {isPopupOpened && <FeedbackModal />}
    </Fragment>
  );
};

FeedbackPopup.propTypes = {
  isFeedbackBetaFeatureEnabled: PropTypes.bool.isRequired,
  isPopupOpened: PropTypes.bool.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  toggleFeedbackPopup: PropTypes.func.isRequired,
};

export default FeedbackPopup;
